export const START_SYNC = "START_SYNC";
export const START_SYNC_ERROR = "START_SYNC_ERROR";
export const START_SYNC_SUCCESS = "START_SYNC_SUCCESS";
export const PROGRESS_SYNC = "PROGRESS_SYNC";
export const PROGRESS_SYNC_ERROR = "PROGRESS_SYNC_ERROR";
export const PROGRESS_SYNC_SUCCESS = "PROGRESS_SYNC_SUCCESS";
export const CANCEL_SYNC = "CANCEL_SYNC";
export const CANCEL_SYNC_SUCCESS = "CANCEL_SYNC_SUCCESS";
export const CANCEL_SYNC_ERROR = "CANCEL_SYNC_ERROR";

/**
 * Start sync.
 * @param {Object} item - Municipal object.
 * @param {Object} history - React Router history.
 * @param {string} syncType - 'full' | 'delta'.
 */
export const startSync = (item, history, syncType = "full") => ({
  type: START_SYNC,
  payload: {
    item,
    history,
    syncType,
  },
});

/**
 * Success action for starting sync.
 * @param {Object} data - Started sync data.
 */
export const startSyncSuccess = (data) => ({
  type: START_SYNC_SUCCESS,
  payload: data,
});

/**
 * Error action for starting sync.
 * @param {Error|string} error - Error details.
 */
export const startSyncError = (error) => ({
  type: START_SYNC_ERROR,
  payload: error,
});

/**
 * sync process.
 * @param {string|number} id - Municipal ID.
 * @param {boolean} [loading=true] - Loading flag.
 * @returns {{ type: string, payload: Object }}
 */
export const progressSync = (id, loading = true) => {
  return {
    type: PROGRESS_SYNC,
    payload: {
      id,
      loading,
    },
  };
};

/**
 * Action dispatched when sync are successfully loaded.
 * @param {Object} data - Loaded log data.
 */
export const progressSyncSuccess = (data) => ({
  type: PROGRESS_SYNC_SUCCESS,
  payload: data,
});

/**
 * Action dispatched when sync fails.
 * @param {Error|Object|string} error - Error information.
 */
export const progressSyncError = (error) => ({
  type: PROGRESS_SYNC_ERROR,
  payload: error,
});

/**
 * Cancel a running Entra sync by jobId.
 * @param {string} jobId - Sync job ID.
 * @param {Object} history - React Router history for navigation.
 */
export const cancelSync = (jobId, history) => ({
  type: CANCEL_SYNC,
  payload: { jobId, history },
});

export const cancelSyncSuccess = (data) => ({
  type: CANCEL_SYNC_SUCCESS,
  payload: data,
});

export const cancelSyncError = (error) => ({
  type: CANCEL_SYNC_ERROR,
  payload: error,
});